import { useState } from "react";
import Dropdown from "../../gui/Dropdown/Dropdown";
import { TPrimitiveId, TSelect } from "../../gui/Select/Select";
import GUI from "../../gui/GUI";
import SearchInput from "../../gui/TextInput/SearchInput";
import { usePath } from "../../libs/path/PathProvider";

export default function MealSearch(props:{className:string}){
    const {setQuery,query} = usePath()
    const onSearch = (search:string) => setQuery({search})
    const defaultValue = query["search"] as string || ""
    return <div className={GUI.joinClass("search",props.className)}>
        <SearchInput placeholder="Search Meal" canClear={true} defaultValue={defaultValue} onSearch={onSearch}/>
    </div>        
}